import { render, staticRenderFns } from "./StartStop.vue?vue&type=template&id=5b09fad5"
import script from "./StartStop.vue?vue&type=script&lang=js"
export * from "./StartStop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports